const state = {
  states: [],
};

const getters = {
  getStateByLabel(state) {
    return (label) => state.states.find((s) => s.label === label);
  },
  getStateByName(state) {
    return (name) => state.states.find((s) => s.name === name);
  },
};

const actions = {
  loadStates(context) {
    // TODO reemplazar ver de cambiar el parametro -> q siempre se traigan el "no estado"
    return this.$services
      .resource(context.state.serviceName)
      .get({ with_no_activity_state: true })
      .then((res) => res.data.data)
      .then(({ states }) => {
        context.commit('SET_STATES', states);
        return states;
      });
  },
};

const mutations = {
  SET_STATES(state, values) {
    state.states = values;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
